var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnectionError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 526.109,
    height: 382.396,
    viewBox: "0 0 526.109 382.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8573",
    "data-name": "Caminho 8573",
    d: "M97.647,583.1l507.537-3s33.176-207.978-64.3-218.932S463.94,233.71,355.653,206.7,215.417,294.587,160.8,379.833,69.4,449.826,97.647,583.1Z",
    transform: "translate(-87.893 -202.676)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.249,
    y1: 0.618,
    x2: 0.98,
    y2: 0.316,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5ed1ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#d7eec2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5ed1ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#d7eec2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Connection_Error",
    "data-name": "Connection Error",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8572",
    "data-name": "Caminho 8572",
    d: "M97.647,583.1l507.537-3s33.176-207.978-64.3-218.932S463.94,233.71,355.653,206.7,215.417,294.587,160.8,379.833,69.4,449.826,97.647,583.1Z",
    transform: "translate(-84.517 -202.676)",
    fill: "#ffeaea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7143",
    "data-name": "Grupo 7143",
    transform: "translate(3.376 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7142",
    "data-name": "Grupo 7142",
    transform: "translate(-76.486 -142.146)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_692",
    "data-name": "Elipse 692",
    cx: 71.502,
    cy: 71.502,
    rx: 71.502,
    ry: 71.502,
    transform: "translate(44.277 330.327)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_693",
    "data-name": "Elipse 693",
    cx: 71.502,
    cy: 71.502,
    rx: 71.502,
    ry: 71.502,
    transform: "translate(0 299.002)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_694",
    "data-name": "Elipse 694",
    cx: 113.073,
    cy: 113.073,
    rx: 113.073,
    ry: 113.073,
    transform: "translate(186.844 118.215)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_695",
    "data-name": "Elipse 695",
    cx: 91.163,
    cy: 96.64,
    rx: 91.163,
    ry: 96.64,
    transform: "translate(176.953 147.365) rotate(-18.967)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_696",
    "data-name": "Elipse 696",
    cx: 91.163,
    cy: 96.64,
    rx: 91.163,
    ry: 96.64,
    transform: "translate(211.213 59.259) rotate(-18.967)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_697",
    "data-name": "Elipse 697",
    cx: 91.163,
    cy: 96.64,
    rx: 91.163,
    ry: 96.64,
    transform: "translate(421.033 309.23) rotate(-18.967)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_698",
    "data-name": "Elipse 698",
    cx: 91.163,
    cy: 96.64,
    rx: 91.163,
    ry: 96.64,
    transform: "translate(479.048 301.082) rotate(-18.967)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 12
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7149",
    "data-name": "Grupo 7149",
    transform: "translate(0 46.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8574",
    "data-name": "Caminho 8574",
    d: "M91.207,500.305c17.932-8.507,38.89,17.793,33.074,38.786s-1.163,32.145,1,36.171,3.759,25.308-3.7,34.18S98.957,604.688,99.573,579.6,67.048,511.765,91.207,500.305Z",
    transform: "translate(-82.377 -363.998)",
    fill: "#4ac6bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8575",
    "data-name": "Caminho 8575",
    d: "M134.321,640.008a.849.849,0,0,0,.232-.032.861.861,0,0,0,.6-1.059c-2.228-7.982-5.245-17.058-8.44-26.667-7.176-21.582-15.309-46.044-14.451-59.775a.86.86,0,0,0-1.718-.108c-.879,14.066,6.957,37.634,14.536,60.426,3.188,9.589,6.2,18.645,8.415,26.586A.861.861,0,0,0,134.321,640.008Z",
    transform: "translate(-93.278 -384.52)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8576",
    "data-name": "Caminho 8576",
    d: "M170.85,520.255c20.4,3.923,32.522,35.93,18.274,49.867s-33.142,14.558-36.551,47.39l-9.18-1.269s-12.5-13.6-5.063-35.9,10.531-14.557,15.8-37.788S162.795,518.707,170.85,520.255Z",
    transform: "translate(-103.17 -372.178)",
    fill: "#50a5a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8577",
    "data-name": "Caminho 8577",
    d: "M153.4,642.638h.061a.86.86,0,0,0,.8-.918c-.993-13.908,6.929-69.613,18.6-75.363a.86.86,0,1,0-.761-1.543c-13.326,6.567-20.462,64.266-19.549,77.025A.861.861,0,0,0,153.4,642.638Z",
    transform: "translate(-109.569 -389.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8578",
    "data-name": "Caminho 8578",
    d: "M130.993,767.792h21.819l8.144-89.128a4.613,4.613,0,0,0-4.594-5.033H127.442a4.613,4.613,0,0,0-4.593,5.033Z",
    transform: "translate(-98.072 -431.881)",
    fill: "#c7c7e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2186",
    "data-name": "Ret\\xE2ngulo 2186",
    width: 10.499,
    height: 138.497,
    transform: "translate(118.768 195.298)",
    fill: "#c7c7e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2187",
    "data-name": "Ret\\xE2ngulo 2187",
    width: 10.499,
    height: 138.497,
    transform: "translate(179.408 195.298)",
    fill: "#c7c7e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2188",
    "data-name": "Ret\\xE2ngulo 2188",
    width: 86.433,
    height: 135.315,
    transform: "translate(261.804 195.298)",
    fill: "#e7e6f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8579",
    "data-name": "Caminho 8579",
    d: "M597.511,733.979H505.986V593.572h91.525Zm-86.433-5.092h81.338V598.664H511.078Z",
    transform: "translate(-246.728 -400.82)",
    fill: "#c7c7e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2189",
    "data-name": "Ret\\xE2ngulo 2189",
    width: 5.222,
    height: 135.315,
    transform: "translate(302.41 195.298)",
    fill: "#c7c7e3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_699",
    "data-name": "Elipse 699",
    cx: 3.814,
    cy: 3.814,
    rx: 3.814,
    ry: 3.814,
    transform: "translate(315.242 256.416)",
    fill: "#c7c7e3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_700",
    "data-name": "Elipse 700",
    cx: 3.814,
    cy: 3.814,
    rx: 3.814,
    ry: 3.814,
    transform: "translate(288.948 256.416)",
    fill: "#c7c7e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2190",
    "data-name": "Ret\\xE2ngulo 2190",
    width: 278.463,
    height: 21.664,
    transform: "translate(95.521 186.799)",
    fill: "#c7c7e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2191",
    "data-name": "Ret\\xE2ngulo 2191",
    width: 299.46,
    height: 14.498,
    transform: "translate(85.022 184.299)",
    fill: "#e7e6f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7146",
    "data-name": "Grupo 7146",
    transform: "translate(124.117 55.296)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2192",
    "data-name": "Ret\\xE2ngulo 2192",
    width: 183.942,
    height: 119.242,
    rx: 10,
    transform: "translate(14.294)",
    fill: "#c7c7e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2193",
    "data-name": "Ret\\xE2ngulo 2193",
    width: 172.657,
    height: 108.71,
    rx: 10,
    transform: "translate(19.56 5.266)",
    fill: "#ececf5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2194",
    "data-name": "Ret\\xE2ngulo 2194",
    width: 59.809,
    height: 9.028,
    transform: "translate(77.489 116.985)",
    fill: "#c7c7e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8580",
    "data-name": "Caminho 8580",
    d: "M285.212,567.5H499.175a.037.037,0,0,1,.037.037v2.228a4.883,4.883,0,0,1-4.883,4.883H290.058a4.883,4.883,0,0,1-4.883-4.883v-2.227a.037.037,0,0,1,.011-.026A.036.036,0,0,1,285.212,567.5Z",
    transform: "translate(-285.175 -446.001)",
    fill: "#c7c7e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7144",
    "data-name": "Grupo 7144",
    transform: "translate(43.294 28.21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2195",
    "data-name": "Ret\\xE2ngulo 2195",
    width: 37.141,
    height: 9.644,
    rx: 4.822,
    transform: "matrix(0.679, 0.734, -0.734, 0.679, 7.844, 0)",
    fill: "#5f6386"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2196",
    "data-name": "Ret\\xE2ngulo 2196",
    width: 37.141,
    height: 9.644,
    rx: 4.822,
    transform: "matrix(-0.734, 0.679, -0.679, -0.734, 33.819, 7.847)",
    fill: "#5f6386"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7145",
    "data-name": "Grupo 7145",
    transform: "translate(133.946 27.459)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2197",
    "data-name": "Ret\\xE2ngulo 2197",
    width: 9.644,
    height: 37.141,
    rx: 4.822,
    transform: "matrix(0.734, -0.679, 0.679, 0.734, 0.763, 6.547)",
    fill: "#5f6386"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2198",
    "data-name": "Ret\\xE2ngulo 2198",
    width: 37.141,
    height: 9.644,
    rx: 4.822,
    transform: "matrix(0.734, -0.679, 0.679, 0.734, 0, 25.974)",
    fill: "#5f6386"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2199",
    "data-name": "Ret\\xE2ngulo 2199",
    width: 82.003,
    height: 12.037,
    rx: 6.019,
    transform: "translate(64.699 74.855)",
    fill: "#5f6386"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7147",
    "data-name": "Grupo 7147",
    transform: "translate(318.902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8581",
    "data-name": "Caminho 8581",
    d: "M767.123,802.57l-26.317,5.255a3.647,3.647,0,0,0-2.931,3.576h0a3.646,3.646,0,0,0,3.647,3.646h37.416l-.752-12.345Z",
    transform: "translate(-655.598 -481.906)",
    fill: "#1c5276"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8582",
    "data-name": "Caminho 8582",
    d: "M785.015,788.255h11.062v10.661a3.807,3.807,0,0,1-3.807,3.807h-3.447a3.807,3.807,0,0,1-3.807-3.807V788.255Z",
    transform: "translate(-673.887 -476.352)",
    fill: "#fb855f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8583",
    "data-name": "Caminho 8583",
    d: "M634.05,797.9l-26.813-1.1a3.647,3.647,0,0,0-3.693,2.784h0a3.648,3.648,0,0,0,2.684,4.407l36.362,8.819,2.179-12.175Z",
    transform: "translate(-603.44 -479.666)",
    fill: "#1c5276"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8584",
    "data-name": "Caminho 8584",
    d: "M0,0H11.062V10.661a3.807,3.807,0,0,1-3.807,3.807H3.808A3.807,3.807,0,0,1,0,10.661V0Z",
    transform: "translate(32.286 309.622) rotate(13.634)",
    fill: "#fb855f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8585",
    "data-name": "Caminho 8585",
    d: "M669.148,337.869s5.591,61.158-11.516,61.391c-19.291.264,1.159-64.092,1.159-64.092S662.884,331.9,669.148,337.869Z",
    transform: "translate(-621.251 -300.219)",
    fill: "#eb8f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8586",
    "data-name": "Caminho 8586",
    d: "M702.918,372.285s-12.651,5.779-25.655,12.655c-14.417,7.622-29.165,16.777-25.383,24.922,8.327,17.932,60.632-20.809,60.632-20.809C719.709,381.786,711.86,370.75,702.918,372.285Z",
    transform: "translate(-622.001 -314.91)",
    fill: "#eb8f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8587",
    "data-name": "Caminho 8587",
    d: "M674.359,326.737a13.316,13.316,0,0,0,5.365-3.893c1.8-2.537,2.7-4.468,6.015-5.994s1.06-4.9-1.755-3.445-6.938,4.4-7.573.419,6.206-11.69-.084-12.985c0,0,2.191-4.2.231-4.962s-3.97,3.033-3.97,3.033-2.782-4.948-6.153,5.61c0,0-2.3-1.39-3.227.568-1.474,3.131-1.643,10.88-.013,16.831C665.844,331.594,674.359,326.737,674.359,326.737Z",
    transform: "translate(-626.174 -285.282)",
    fill: "#eb8f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8588",
    "data-name": "Caminho 8588",
    d: "M699.769,377.944q3.336,12.856,12.767,25.69l26.872-20.585-10.325-17.521Z",
    transform: "translate(-640.813 -312.344)",
    fill: "#ea6565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8589",
    "data-name": "Caminho 8589",
    d: "M683.048,304.048s-1.9,2.077-3.687,12.007",
    transform: "translate(-632.896 -288.491)",
    fill: "none",
    stroke: "#d16b70",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8590",
    "data-name": "Caminho 8590",
    d: "M677.068,300.9s-2.995,7.308-3.484,12.633",
    transform: "translate(-630.654 -287.27)",
    fill: "none",
    stroke: "#d16b70",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8591",
    "data-name": "Caminho 8591",
    d: "M668.737,310.063s-.5,4.031-.766,7.241",
    transform: "translate(-628.477 -290.825)",
    fill: "none",
    stroke: "#d16b70",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8592",
    "data-name": "Caminho 8592",
    d: "M686.51,603.086h0a15.279,15.279,0,0,1-10.814-18c7.409-33.519,16.065-66.441,23.776-91.025h34.446c-8.921,27.966-20.6,68.665-28.52,98.257a15.287,15.287,0,0,1-18.888,10.769Z",
    transform: "translate(-631.334 -362.212)",
    fill: "#5f6386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8593",
    "data-name": "Caminho 8593",
    d: "M682.7,625.467h0a15.227,15.227,0,0,0-18.987,11.445c-6.257,28.924-14.78,66.3-18.62,84.888l24.929,6.973c4.823-21.059,16.359-58.693,23.294-84.721A15.227,15.227,0,0,0,682.7,625.467Z",
    transform: "translate(-619.602 -412.976)",
    fill: "#5f6386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8594",
    "data-name": "Caminho 8594",
    d: "M777.235,603.623h0A15.279,15.279,0,0,1,761.971,589.2c-1.9-34.273-2.728-69.386-1.925-95.139H793.5c-1.057,29.335-1.317,63.467-.979,94.1a15.287,15.287,0,0,1-15.286,15.458Z",
    transform: "translate(-664.081 -362.212)",
    fill: "#5f6386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8595",
    "data-name": "Caminho 8595",
    d: "M778.645,624.924h0a15.227,15.227,0,0,0-15.2,16.135c1.766,29.541,4.284,66.033,5.6,84.974h25.887c-1.028-21.58-.716-59.14-1.048-86.071A15.227,15.227,0,0,0,778.645,624.924Z",
    transform: "translate(-665.506 -412.984)",
    fill: "#5f6386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8596",
    "data-name": "Caminho 8596",
    d: "M714.721,442.788s.779-67.894,17.8-77.559c9.759-5.541,29.958-4.036,40.258,3.619,10.4,7.726,3.053,73.94,3.053,73.94Z",
    transform: "translate(-646.614 -310.939)",
    fill: "#ea6565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8597",
    "data-name": "Caminho 8597",
    d: "M736.463,434.766s60.984,7.243,57.657,24.025c-3.752,18.924-62.453-14.457-62.453-14.457S729.328,439.655,736.463,434.766Z",
    transform: "translate(-653.047 -339.207)",
    fill: "#eb8f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8598",
    "data-name": "Caminho 8598",
    d: "M782.844,381.791s2.919,13.6,6.831,27.778c4.337,15.721,10.1,32.1,18.869,30.156,19.305-4.266-7.26-63.687-7.26-63.687C795.739,367.442,783.271,372.733,782.844,381.791Z",
    transform: "translate(-673.045 -314.731)",
    fill: "#eb8f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8599",
    "data-name": "Caminho 8599",
    d: "M726.915,425.93a13.336,13.336,0,0,0-2.693-6.059c-2.107-2.293-3.811-3.572-4.613-7.129s-4.57-2.055-3.733,1,2.859,7.7-1.163,7.5-10.146-8.5-12.72-2.616c0,0-3.654-3.017-4.806-1.258s2.142,4.514,2.142,4.514-5.418,1.693,4.209,7.185c0,0-1.836,1.966-.116,3.274,2.754,2.093,10.3,3.868,16.464,3.511C729.893,435.268,726.915,425.93,726.915,425.93Z",
    transform: "translate(-639.717 -329.861)",
    fill: "#eb8f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8600",
    "data-name": "Caminho 8600",
    d: "M782.644,404.229c9.993.048,19.146-2.678,27.837-6.933l-9.254-19.837a13.5,13.5,0,0,0-16.424-7.126l-10.982,3.577Z",
    transform: "translate(-669.544 -313.949)",
    fill: "#ea6565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8601",
    "data-name": "Caminho 8601",
    d: "M705.191,423.659s1.637,2.287,10.979,6.1",
    transform: "translate(-642.917 -334.898)",
    fill: "none",
    stroke: "#d16b70",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8602",
    "data-name": "Caminho 8602",
    d: "M700.839,428.98s6.526,4.449,11.633,6.033",
    transform: "translate(-641.229 -336.962)",
    fill: "none",
    stroke: "#d16b70",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8603",
    "data-name": "Caminho 8603",
    d: "M707.716,440.719s3.838,1.329,6.924,2.255",
    transform: "translate(-643.897 -341.517)",
    fill: "none",
    stroke: "#d16b70",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8604",
    "data-name": "Caminho 8604",
    d: "M768.045,348.4c-3.754,7.18-11.542,6.468-11.761,6.483a13.941,13.941,0,0,0,.962-3.593l0,0C757.6,351.085,771.561,341.672,768.045,348.4Z",
    transform: "translate(-662.74 -304.76)",
    fill: "#d16b70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8605",
    "data-name": "Caminho 8605",
    d: "M791.1,312.843s-.562,6.787-10.43,13.778c-10.343,7.33,1.43-15.2,1.43-15.2Z",
    transform: "translate(-670.551 -291.353)",
    fill: "#8e3332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8606",
    "data-name": "Caminho 8606",
    d: "M753.4,307.083s-1.4,5.849-3.208,12.412c-2.589,9.383-2.81,16.969,6.748,16.969,16.053,0,14.984-26.638,14.984-26.638Z",
    transform: "translate(-659.781 -289.669)",
    fill: "#eb8f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8607",
    "data-name": "Caminho 8607",
    d: "M764.879,301.8s-24.073-.54-20.753-16.82,12.76,3.9,17.656,3.9c5.743,0,21.383.836,15.643,14.505C775.936,306.931,773.552,302.351,764.879,301.8Z",
    transform: "translate(-657.901 -278.63)",
    fill: "#8e3332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8608",
    "data-name": "Caminho 8608",
    d: "M720.612,409.169l-1.217-.13c.015-.14,1.561-14.131,7.617-26.078l1.091.551C722.152,395.264,720.626,409.031,720.612,409.169Z",
    transform: "translate(-648.428 -319.108)",
    fill: "#c45454"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_351",
    "data-name": "Linha 351",
    x1: 7.322,
    y2: 4.538,
    transform: "translate(40.852 73.923)",
    fill: "none",
    stroke: "#d16b70",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_352",
    "data-name": "Linha 352",
    x2: 7.186,
    y2: 2.481,
    transform: "translate(118.98 102.835)",
    fill: "none",
    stroke: "#d16b70",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2200",
    "data-name": "Ret\\xE2ngulo 2200",
    width: 1.224,
    height: 19.703,
    transform: "matrix(0.965, -0.264, 0.264, 0.965, 110.845, 75.995)",
    fill: "#c45454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8609",
    "data-name": "Caminho 8609",
    d: "M775.582,364.818c-1.314,9.447-10.343,14.284-18.718,12.642s-10.179-12.642-10.179-12.642l5.014-1.826,18.7.29S775.689,364.037,775.582,364.818Z",
    transform: "translate(-659.016 -311.36)",
    fill: "#c45454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8610",
    "data-name": "Caminho 8610",
    d: "M789.618,412.916l-.068-1.224c8.637-.48,23.252-7.9,23.4-7.979l.557,1.09C812.9,405.116,798.511,412.422,789.618,412.916Z",
    transform: "translate(-675.646 -327.159)",
    fill: "#c45454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8611",
    "data-name": "Caminho 8611",
    d: "M715.487,402.819c-4.278-5.593-9.241-19.286-9.449-19.866l1.151-.415c.051.141,5.107,14.1,9.269,19.538Z",
    transform: "translate(-643.245 -318.943)",
    fill: "#c45454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8612",
    "data-name": "Caminho 8612",
    d: "M736.489,540.709l24.956.985-2.955-21.673s-9.523-.329-11.822-.329S736.489,540.709,736.489,540.709Z",
    transform: "translate(-655.06 -372.157)",
    fill: "#5f6386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8613",
    "data-name": "Caminho 8613",
    d: "M752.977,495.549l-3.612,22.33,9.523,2.627",
    transform: "translate(-660.056 -362.789)",
    fill: "none",
    stroke: "#30354f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_353",
    "data-name": "Linha 353",
    x2: 9.194,
    y2: 23.642,
    transform: "translate(119.192 132.432)",
    fill: "none",
    stroke: "#30354f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_354",
    "data-name": "Linha 354",
    x1: 15.761,
    y2: 26.27,
    transform: "translate(60.085 132.103)",
    fill: "none",
    stroke: "#30354f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8614",
    "data-name": "Caminho 8614",
    d: "M647.177,765.428,645.1,776.319l24.929,6.973,2.437-9Z",
    transform: "translate(-619.602 -467.496)",
    fill: "none",
    stroke: "#30354f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8615",
    "data-name": "Caminho 8615",
    d: "M770.827,773.476l1.088,10.192H797.8l-.375-10.192Z",
    transform: "translate(-668.382 -470.619)",
    fill: "none",
    stroke: "#30354f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_701",
    "data-name": "Elipse 701",
    cx: 4.844,
    cy: 4.844,
    rx: 4.844,
    ry: 4.844,
    transform: "translate(105.564 32.606)",
    fill: "#eb8f90"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_704",
    "data-name": "Elipse 704",
    cx: 10.836,
    cy: 10.836,
    rx: 10.836,
    ry: 10.836,
    transform: "translate(48.153 211.788)",
    fill: "#494e6d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_705",
    "data-name": "Elipse 705",
    cx: 10.836,
    cy: 10.836,
    rx: 10.836,
    ry: 10.836,
    transform: "translate(101.35 213.758)",
    fill: "#494e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8619",
    "data-name": "Caminho 8619",
    d: "M762.156,363.092c-7.082,0-10.31-8.272-8.407-10.175a6.693,6.693,0,0,0,1.336-2.069h.005a13.939,13.939,0,0,0,.962-3.593l0,0,13.092-11.678c-.707,7.435,2.475,12.655,3.629,16.373S770.209,363.092,762.156,363.092Z",
    transform: "translate(-661.547 -300.722)",
    fill: "#eb8f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8620",
    "data-name": "Caminho 8620",
    d: "M771.278,324.394s-2.628,6.4-5.911,8.374-8.7-3.284-16.586-1.806c0,0-.657,8.7,2.134,13.465,0,0,8.374,1.641,13.3-3.777a76.064,76.064,0,0,0,8.374-11.329Z",
    transform: "translate(-659.803 -296.385)",
    fill: "#8e3332"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8621",
    "data-name": "Caminho 8621",
    d: "M760.041,345.193l-6.454.143s-.239-5.709,3.311-5.724S760.041,345.193,760.041,345.193Z",
    transform: "translate(-662.356 -301.205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8622",
    "data-name": "Caminho 8622",
    d: "M723.114,406.829s19.181,5.965,38.637,1.163l1.852,6.773a58.3,58.3,0,0,1-42.011-1.146Z",
    transform: "translate(-649.28 -328.368)",
    fill: "#c45454"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7148",
    "data-name": "Grupo 7148",
    transform: "translate(325.571 123.758)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8623",
    "data-name": "Caminho 8623",
    d: "M628.7,530.169c-1.454-9.887-8.433-25.3-11.632-30.679s-6.4-24.136,8-17.085,11.341,40.058,9.3,47.764Z",
    transform: "translate(-614.337 -480.84)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8624",
    "data-name": "Caminho 8624",
    d: "M663.45,486.545c-8.746-3.182-18.03,9.6-18.757,45.657h6.4S681.043,492.945,663.45,486.545Z",
    transform: "translate(-626.114 -482.871)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8625",
    "data-name": "Caminho 8625",
    d: "M634.29,530.787a.4.4,0,0,1-.394-.493c1.53-6.784.316-17.126-3.244-27.663-3.448-10.2-8.267-18.055-12.575-20.489a.4.4,0,0,1,.4-.7c4.474,2.526,9.434,10.548,12.944,20.931,3.607,10.676,4.828,21.181,3.267,28.1A.4.4,0,0,1,634.29,530.787Z",
    transform: "translate(-615.712 -481.054)",
    fill: "#b0b0d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8626",
    "data-name": "Caminho 8626",
    d: "M649.674,534.957a.411.411,0,0,1-.073-.007.4.4,0,0,1-.324-.47c2.17-11.827,14.434-41.8,14.558-42.1a.4.4,0,0,1,.747.306c-.122.3-12.356,30.2-14.511,41.94A.4.4,0,0,1,649.674,534.957Z",
    transform: "translate(-627.89 -485.224)",
    fill: "#b0b0d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8627",
    "data-name": "Caminho 8627",
    d: "M642.736,567.284H625.449l-7.7-13.453a2.855,2.855,0,0,1-.377-1.417h0a2.852,2.852,0,0,1,2.853-2.852h27.737a2.852,2.852,0,0,1,2.853,2.853h0a2.853,2.853,0,0,1-.377,1.417Z",
    transform: "translate(-615.514 -507.503)",
    fill: "#eeedff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionError);
export default __webpack_public_path__ + "static/media/Connection Error.eb148422.svg";
export { ForwardRef as ReactComponent };